import { cn } from "@/lib/utils";

/** Yoqish/o'chirish (iOS uslubi): yorliq chapda, ixtiyoriy izoh bilan; yoqiq -- brend sariq */
export function Toggle({ label, hint, checked, onChange, disabled }: { label: string; hint?: string; checked: boolean; onChange: (v: boolean) => void; disabled?: boolean }) {
  return (
    <label className={cn("flex items-center justify-between gap-3 text-[13px]", disabled && "text-muted")}>
      <span>
        {label}
        {hint && <span className="ml-2 text-[11px] text-muted">· {hint}</span>}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn("relative h-[24px] w-11 shrink-0 rounded-full transition-colors duration-200 disabled:opacity-50", checked ? "bg-accent" : "bg-border")}
      >
        <span className={cn("absolute top-[2px] h-[20px] w-[20px] rounded-full bg-white shadow-pill transition-[left] duration-200", checked ? "left-[22px]" : "left-[2px]")} />
      </button>
    </label>
  );
}
